module.exports = __webpack_public_path__ + "img/ford-logo.1fc4626c.png";